module.exports = __webpack_public_path__ + "static/media/someone_in_the_room.f5995208.mp3";